import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import {
  LastPage,
  AllInclusive,
  Add,
  MoreVert,
  Schedule,
  Block,
  Subway,
  AirportShuttle,
  Edit,
  Delete,
  Done,
  Image,
  DevicesOther,
  SettingsCell
} from "@material-ui/icons";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,DatePicker
} from "@material-ui/pickers";

import {
  TableRow,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  Grid,
  List,ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  CircularProgress,
  FormHelperText,Stepper,Step,StepLabel,ListItemSecondaryAction,Link
} from "@material-ui/core";

import { withLocalize, Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import API from './api';

import API_ADMIN from './api_admin';

import UserInfo from "./login_info";

import { useSnackbar } from 'notistack';

import axios from 'axios';

import {TransportService,AdminService} from "./../../utils/web_config_2";

import {useHistory } from "react-router-dom";


import Format from "date-fns/format";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  type_list:{
    backgroundColor: theme.palette.background.paper,
  },
  btn: {
    textTransform: "capitalize",
    margin:theme.spacing(1)
  },
  formTitle: {
    flexGrow: 1,
  },
}));

function Devices() {
    const classes = useStyles1();
    const [message,setMessage]=useState("Loading...");
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [title,setTitle]=useState("All Devices");
  
    const [operatorData, setOperatorData] = useState({});
    
    const history = useHistory();
  
  
    const columns = [
      
      {
        name: "id",
        label: "id",
        options: {
          display:false,
         filter: true,
         sort: true,
        }
       },
       {
        name: "name",
        label: "Name",
        options: {
         filter: true,
         sort: true,
        }
       },
       {
        name: "device_type",
        label: "Type",
        options: {
         filter: true,
         sort: true,
        }
       },
      {
       name: "device_id_number",
       label: "Serial Number",
       options: {
        filter: true,
        sort: true,
       }
      },
      {
        name: "status",
        label: <Translate id="operator_vehicle.table.status" />,
        options: {
         filter: true,
         sort: true,
         customBodyRender: (value, tableMeta, updateValue) => {
             if(value=="ACTIVE"){
                return (
                    <Chip
                    variant="outlined"
                    label={value}
                    icon={<Done />}
                    color="primary"
                />
                  );
             }else{
                return (
                    <Chip
                    variant="outlined"
                    label={value}
                    color="secondary"
                />
                  );
             }
          
        }
        }
       }
     ];
    
     
     const options = {
      textLabels: {
        body: {
          noMatch: message
        },
      },
       filterType: 'checkbox',
       download:true,
       responsive:"standard",
       selectableRows:false,
       rowsPerPage: 10,
       elevation:0
    };

     useEffect(()=>{
      var data = {};
      const data1 = localStorage.getItem("nx_op");
      if (data1 != null) {
        data = JSON.parse(data1);
      }
      setOperatorData(data);
  
      get_device(data.token)
     },[]);



     //get all devices 

     const [types,setTypes]=useState([]);

     const [devices,setDevices]=useState([]);

     const [counts,setCounts]=useState([]);

     const [temp,setTemp]=useState([]);


     const [deviceLoad,setDeviceLoad]=useState(false);
     const get_device=(token)=>{
        setDeviceLoad(true);
        setMessage("Loading...");
        axios.defaults.baseURL = new TransportService().BASE_URL;
        const deviceInstance = axios.create(new TransportService().setHeaders(token));
        deviceInstance.get('/api/v1/integrations/getDevicesByOrganization/'+new UserInfo().ORG_ID)
        .then(res=>{
            var objs=res.data;
            var t=[];
            var v=[];
            objs.map((o)=>{
                t.push(o['device_type']);
            });
            let unique_type=t.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);

            var v=[];


            unique_type.map((t)=>{
                let count=0;
                objs.map((o)=>{
                    if(o['device_type']==t){
                        count++;
                    }
                });
                v.push(count);
            });

            setCounts(v);
            setTypes(unique_type);
            setDevices(objs);
            setDeviceLoad(false);
            setTemp(objs);
        })
        .catch(err=>{
            setDeviceLoad(false);
            if(err.response){
              if(err.response.status==404){
                setMessage("Not found");
              }
            }
        });
     } 
return(
    <div className={classes.root}>

    <Box display="flex">

<Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>

<Box mr={1}> <DevicesOther fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Devices</b></Typography>

</Box>



    </Box>

{/* devices table  */}
<Grid container>
<Grid md={4} xs={12} lg={4}>

 <Box mt={1} mr={1}>
  
 <Paper elevation={0}>
 {/* {loadTypes&&<LinearProgress />} */}
 
 <Box display="flex" alignItems="center">
   <Box display="flex" className={classes.formTitle} ml={1}><Typography variant="h6">Device Types</Typography></Box>
<Box p={1}><Typography style={{cursor:"pointer"}} color="primary"><Link href="#" rel="noopener" onClick={()=>{
    setDevices(temp);
    setTitle("All");
}}>All</Link></Typography></Box>
</Box>
 <List className={classes.type_list}>
   {types.map((t,i)=>{
     return <ListItem onClick={()=>{
        setTitle(t);
        var objs=temp.filter((o)=>o.device_type==t);
        setDevices(objs);

     }} button>
     <ListItemAvatar>
         <SettingsCell fontSize="large"/>
     </ListItemAvatar>
     <ListItemText primary={t}  
     />
      <ListItemSecondaryAction>
            <Chip
            size="small"
                color={"primary"}
                label={counts[i]}
              />
                  </ListItemSecondaryAction>
   </ListItem>
   })}
   </List>
 </Paper>
 
 </Box>
  </Grid>
 <Grid md={8} xs={12} lg={8}>
 <Box mt={1}>
{deviceLoad&&<LinearProgress />}
<MUIDataTable
 title={title}
 data={devices}
 columns={columns}
 options={options}
/>

</Box> 
 </Grid>
</Grid>

</div>
)  ;

}

export default withLocalize(Devices)